import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Server } from '../../types/api';

interface ServerCardProps {
  server: Server;
  disabled?: boolean;
}

export function ServerCard({ server, disabled }: ServerCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getServerName = (): string => {
    const key = `temporaryNumbers.servers.server${server.serverId}`;
    return t(key);
  };

  const handleSelect = () => {
    if (!disabled) navigate(`/temporary-numbers/purchase?serverId=${server.serverId}`);
  };

  return (
    <button
      onClick={handleSelect}
      className={`w-full card-glass rounded-lg p-6 transition-all duration-300 text-left group relative ${
        disabled
          ? 'opacity-60 cursor-not-allowed border-red-500/30'
          : 'hover:border-brand-accent/50 hover:shadow-lg hover:shadow-brand-accent/20 transform hover:scale-105 cursor-pointer'
      }`}
    >
      {disabled && (
        <div className="absolute -top-2.5 left-1/2 -translate-x-1/2">
          <span className="bg-red-500/90 text-white text-[10px] font-heading font-bold px-3 py-1 rounded-full shadow-lg shadow-red-500/30 whitespace-nowrap">
            متوقف - تحت الصيانة
          </span>
        </div>
      )}
      <div className="flex flex-col gap-3">
        <div className="flex items-start justify-between">
          <h3 className={`text-lg font-heading font-semibold transition-colors ${
            disabled ? 'text-red-400' : 'text-neutral-light group-hover:text-brand-accent'
          }`}>
            {getServerName()}
          </h3>
        </div>
        <p className={`text-sm font-body ${disabled ? 'text-red-400/70' : 'text-neutral-medium'}`}>
          {disabled ? 'السيرفر متوقف حالياً' : t(`temporaryNumbers.servers.server${server.serverId}Description`)}
        </p>
      </div>
    </button>
  );
}

